import { Icon, Text, VStack } from "@chakra-ui/react";
import { XCircle } from "@phosphor-icons/react";
import Container from "../components/Container";
import Nav from "../components/nav/Nav";
import Footer from "../components/Footer";

export default function UserActivationFailed() {
  return (
    <VStack gap={0} minH={"100vh"}>
      <Nav />

      <Container flex={1}>
        <VStack px={10} pt={10} pb={20} justify={"center"} flex={1}>
          <Icon as={XCircle} fontSize={150} weight={"thin"} color={"p.500"} />{" "}
          <Text
            fontSize={32}
            fontWeight={600}
            color={"p.500"}
            textAlign={"center"}
          >
            Maaf, akun anda gagal diaktivasi
          </Text>
          <Text fontSize={20} textAlign={"center"}>
            Silahkan mendaftar ulang
          </Text>
        </VStack>
      </Container>

      <Footer />
    </VStack>
  );
}
